import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Alert,
  CircularProgress,
  IconButton,
  TextField,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { updateHrLeaveTransaction } from "../../../api/api";

export default function EditTransactionDialog({ open, onClose, onSuccess, transaction }) {

  const [days, setDays] = useState("");
  const [remarks, setRemarks] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (transaction) {
      setDays(transaction.days);
      setRemarks(transaction.remarks || "");
    }
  }, [transaction]);

  const handleSubmit = async () => {
    if (!days || Number(days) <= 0) {
      setError("Enter a valid number of days");
      return;
    }

    setSaving(true);
    setError("");

    try {
      await updateHrLeaveTransaction(transaction.id, {
        days: Number(days),
        remarks,
      });

      onSuccess?.();
      onClose();
    } catch (err) {
      setError(err?.errors?.[0] || "Failed to update transaction");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        Edit Transaction
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>

        <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
          {transaction?.user_name} · {transaction?.transaction_type}
        </Typography>

        <Stack spacing={2}>
          <TextField
            size="small"
            label="Days"
            type="number"
            value={days}
            onChange={(e) => setDays(e.target.value)}
          />

          <TextField
            size="small"
            label="Remark"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />

          {error && <Alert severity="error">{error}</Alert>}
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={saving}>
          {saving ? <CircularProgress size={20} /> : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}